/* =========================================================
   EYESHELLS: engo-blog.js
   - Article/blog extras (related posts slider, etc.)
   ========================================================= */

(function($){
  $(function(){
    "use strict";

    function jsrelatepost(){
        $('.js_relate_post').slick({
          dots: true,
          arrows:false,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 3,
          slidesToScroll: 2,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                dots: false, 
                arrows: true
              }
            }
          ]
        });
    
      }

    if ($(".js_relate_post").length) { try { jsrelatepost(); } catch(e){} }
  });
})(window.jQuery);
